export default __webpack_public_path__ + "static/media/product_NPC_Hk.da337288.webp";